import React from 'react'
import UPComingPhotos from '../Components/Feed/UPComingPhotos'
import SubNavbar from '../Components/Layout/SubNavbar'


const ComingUpPage = () => {



    return (
        <>
            <SubNavbar />
            <UPComingPhotos />
        </>
    )
}

export default ComingUpPage
